(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4050],{

/***/ 8106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ ExternalUrlService; }
/* harmony export */ });
var ExternalUrlService = {
  getTofuNftAkiverseGCPage: function getTofuNftAkiverseGCPage() {
    return 'https://tofunft.com/collection/akiverse-game-centers/items';
  },
  getTofuNftAkiverseAMPage: function getTofuNftAkiverseAMPage() {
    return 'https://tofunft.com/collection/akiverse-arcade-machines/items';
  },
  getTofuNftAkiverseAPPage: function getTofuNftAkiverseAPPage() {
    return 'https://tofunft.com/collection/akiverse-arcade-parts/items';
  },
  getStakingUrl: function getStakingUrl() {
    return '/staking';
  },
  getAkvLink: function getAkvLink() {
    return "https://quickswap.exchange/#/swap?outputCurrency=".concat("0x659e79849ED57fA5b2a336Cdd03A4D9586A0e36A");
  },
  // TODO: AKVが取得できるぺー時,
  getDiscordLink: function getDiscordLink() {
    return 'https://discord.gg/xEkgQnU7Za';
  },
  getSupportCenterLink: function getSupportCenterLink() {
    return 'https://support.akiverse.io/';
  },
  getPfpOfficialSite: function getPfpOfficialSite() {
    return 'https://pfp.akiverse.io/';
  }
};

/***/ }),

/***/ 2483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ MetamaskService; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(241);
/* harmony import */ var _assets_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1279);




var isServerSide = false;
var MetamaskService = {
  isValidAddress: function isValidAddress(target) {
    return target.length === _assets_constants__WEBPACK_IMPORTED_MODULE_1__/* .WALLET_ADDRESS_LENGTH */ .W3 && target.startsWith(_assets_constants__WEBPACK_IMPORTED_MODULE_1__/* .WALLET_ADDRESS_PREFIX */ .Xc);
  },
  requestConnectionToMetamsk: function () {
    var _requestConnectionToMetamsk = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var provider;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              provider = new ethers__WEBPACK_IMPORTED_MODULE_3__/* .Web3Provider */ .Q(window.ethereum);
              _context.next = 3;
              return provider.send('eth_requestAccounts', []).then(function () {
                return true;
              })["catch"](function () {
                return false;
              });

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function requestConnectionToMetamsk() {
      return _requestConnectionToMetamsk.apply(this, arguments);
    }

    return requestConnectionToMetamsk;
  }(),
  switchToSupportedChain: function switchToSupportedChain() {
    var _window$ethereum$requ, _window$ethereum;

    (_window$ethereum$requ = (_window$ethereum = window.ethereum).request) === null || _window$ethereum$requ === void 0 ? void 0 : _window$ethereum$requ.call(_window$ethereum, {
      method: 'wallet_switchEthereumChain',
      params: [{
        chainId: "0x89"
      }]
    });
  },
  getCurrentChainId: function getCurrentChainId() {
    return MetamaskService.getSigner().getChainId()["catch"](function () {
      return undefined;
    });
  },
  getWalletAddress: function getWalletAddress() {
    return MetamaskService.getSigner().getAddress()["catch"](function (error) {
      console.error(error);
      return undefined;
    });
  },
  getProvider: function getProvider() {
    var _window;

    return new ethers__WEBPACK_IMPORTED_MODULE_3__/* .Web3Provider */ .Q((_window = window) === null || _window === void 0 ? void 0 : _window.ethereum);
  },
  isInstalledMetamask: function isInstalledMetamask() {
    var _window2;

    return isServerSide ? false : !!((_window2 = window) !== null && _window2 !== void 0 && _window2.ethereum);
  },
  getSigner: function getSigner() {
    return MetamaskService.getProvider().getSigner();
  },
  signMessage: function signMessage(message) {
    return MetamaskService.getSigner().signMessage(message);
  }
};

/***/ }),

/***/ 3975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ Absolute; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);


var Absolute = function Absolute(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "absolute flex ".concat(className !== null && className !== void 0 ? className : ''),
    style: style,
    onClick: onClick,
    children: children
  });
};

/***/ }),

/***/ 4582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ Center; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);


var Center = function Center(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "flex flex-row items-center justify-center ".concat(className !== null && className !== void 0 ? className : ''),
    style: style,
    onClick: onClick,
    children: children
  });
};

/***/ }),

/***/ 269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Clickable; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var Clickable = function Clickable(_ref) {
  var className = _ref.className,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: "relative flex transition-all ".concat(props.disabled ? '' : 'active:opacity-40', " ").concat(className !== null && className !== void 0 ? className : '')
  }, props), {}, {
    disabled: props.disabled,
    onClick: function onClick(event) {
      var _props$onClick;

      event.stopPropagation();
      (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, event);
    },
    children: props.children
  }));
};

/***/ }),

/***/ 1078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ HStack; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);


var HStack = function HStack(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "flex flex-row ".concat(className !== null && className !== void 0 ? className : ''),
    onClick: onClick,
    children: children
  });
};

/***/ }),

/***/ 2952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Space; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);


var Space = function Space() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "flex-1"
  });
};

/***/ }),

/***/ 1695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);


var Text = function Text(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
    className: "whitespace-pre-wrap ".concat(className !== null && className !== void 0 ? className : ''),
    style: style,
    children: children
  });
};

/***/ }),

/***/ 5167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ PinkNeonButton; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _bases_Absolute__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3975);
/* harmony import */ var _bases_Center__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4582);
/* harmony import */ var _bases_Clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(269);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);






var PinkNeonButton = function PinkNeonButton(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Default' : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'M' : _ref$size,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_bases_Clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P, {
    className: "items-center justify-center overflow-hidden rounded-full border-[3px]\n      ".concat(ButtonStyle[type], "\n      ").concat(ButtonDisabledStyle[type], "\n      ").concat(ButtonHeight[size], "\n    "),
    disabled: disabled,
    onClick: onClick,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_bases_Center__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M, {
      className: "\n          h-full w-full\n          ".concat(ButtonInnerStyle[type], "\n          ").concat(ButtonXPadding[size], "\n          ").concat(disabled ? 'shadow-transparent' : '', "\n        "),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_bases_Center__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M, {
        className: "\n            h-full w-full font-bold text-white\n            ".concat(ButtonTextSize[size], "\n            ").concat(disabled && type !== 'Selected' ? 'text-neutral-500' : 'text-white', "\n            ").concat(loading ? 'opacity-0' : '', "\n          "),
        children: children
      }), loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_bases_Absolute__WEBPACK_IMPORTED_MODULE_1__/* .Absolute */ .e, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Loading, {})
      }) : null]
    })
  });
};
var ButtonHeight = {
  M: 'h-10',
  S: 'h-8'
};
var ButtonXPadding = {
  M: 'px-8',
  S: 'px-5'
};
var ButtonStyle = {
  Default: 'border-[#FFCBF1] shadow-pink hover:bg-akiverse-pink',
  Sub: 'border-akiverse-pink  hover:bg-akiverse-pink',
  Selected: 'bg-akiverse-pink/50 border-akiverse-pink'
};
var ButtonDisabledStyle = {
  Default: 'disabled:border-neutral-500 disabled:shadow-none disabled:bg-opacity-0',
  Sub: 'disabled:border-neutral-500 disabled:shadow-none disabled:bg-opacity-0',
  Selected: 'disabled:bg-opacity-0'
};
var ButtonTextSize = {
  S: 'text-sm',
  M: 'text-base'
};
var ButtonInnerStyle = {
  Default: 'shadow-pink-inset',
  Sub: '',
  Selected: ''
};

var Loading = function Loading() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
    className: "flex justify-center",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "h-6 w-6 animate-spin rounded-full border-[3px] border-white border-t-transparent border-opacity-70"
    })
  });
};

/***/ }),

/***/ 9275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ GlobalNavigationHeader_Layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/views/parts/bases/Absolute.tsx
var Absolute = __webpack_require__(3975);
// EXTERNAL MODULE: ./src/views/parts/bases/Clickable.tsx
var Clickable = __webpack_require__(269);
// EXTERNAL MODULE: ./src/views/parts/bases/HStack.tsx
var HStack = __webpack_require__(1078);
// EXTERNAL MODULE: ./src/views/parts/bases/Space.tsx
var Space = __webpack_require__(2952);
// EXTERNAL MODULE: ./src/views/parts/bases/Text.tsx
var Text = __webpack_require__(1695);
;// CONCATENATED MODULE: ./public/images/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.2f018d84.png","height":216,"width":870,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEX///////////////////////////////8pK8DIAAAACHRSTlNFm22NI1Jbe4VuAmwAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAaSURBVAiZY2BgZGZkZmRkYWBiYmBgYGVnAwABBAAl2KbwAAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/images/metamaskLogo.png
var metamaskLogo = __webpack_require__(6912);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(2120);
// EXTERNAL MODULE: ./src/views/parts/commons/Spinner.tsx
var Spinner = __webpack_require__(4974);
// EXTERNAL MODULE: ./src/views/parts/bases/Center.tsx
var Center = __webpack_require__(4582);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(4762);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./src/views/parts/bases/Fixed.tsx
var Fixed = __webpack_require__(2624);
// EXTERNAL MODULE: ./src/views/parts/bases/VStack.tsx
var VStack = __webpack_require__(2326);
// EXTERNAL MODULE: ./src/views/parts/buttons/PinkNeonButton.tsx
var PinkNeonButton = __webpack_require__(5167);
;// CONCATENATED MODULE: ./public/images/loginDialogLeftTop.png
/* harmony default export */ var loginDialogLeftTop = ({"src":"/_next/static/media/loginDialogLeftTop.cf037875.png","height":294,"width":168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAElBMVEUB++sA+uxMaXEF+usB+usA+uvnaVlvAAAABnRSTlMQSAAEJkMu8S1QAAAACXBIWXMAACE4AAAhOAFFljFgAAAAHElEQVQImWNgYGRhYWZgZWFiYmJgZMBOMjDDSQAHigBK0cEXSgAAAABJRU5ErkJggg==","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/loginDialogTop.png
/* harmony default export */ var loginDialogTop = ({"src":"/_next/static/media/loginDialogTop.68201e36.png","height":294,"width":4,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAICAMAAAAPxGVzAAAAA1BMVEVMaXFNx9g6AAAAAXRSTlMAQObYZgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAtJREFUCJljYEAFAAAQAAEhthbSAAAAAElFTkSuQmCC","blurWidth":1,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/loginDialogRightTop.png
/* harmony default export */ var loginDialogRightTop = ({"src":"/_next/static/media/loginDialogRightTop.c8196ec4.png","height":294,"width":168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAElBMVEUA++wA++tMaXEA+usD+usC+usRZcD/AAAABnRSTlMuPwABBBlxtEtzAAAACXBIWXMAACE4AAAhOAFFljFgAAAAH0lEQVQImWNgZWBkZGFgYmJiZGBgYmFiYGBgYsZDAgAGdgA+HvWcRAAAAABJRU5ErkJggg==","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/loginDialogVerticalBorder.png
/* harmony default export */ var loginDialogVerticalBorder = ({"src":"/_next/static/media/loginDialogVerticalBorder.cbff7e6b.png","height":12,"width":54,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEUD+OsF/ukB+uwA+usA+usq/+VykUVnAAAABnRSTlMUDDfpMAFQn4dPAAAACXBIWXMAACE4AAAhOAFFljFgAAAAGElEQVQImWNgZGBiZmJgZGVgZGBhZgEyAAEIACFV6PuEAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/images/loginDialogLeftBottom.png
/* harmony default export */ var loginDialogLeftBottom = ({"src":"/_next/static/media/loginDialogLeftBottom.7a549bf3.png","height":306,"width":168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAADFBMVEVMaXEA+usC++sB++xx+ov/AAAABHRSTlMAPhUyYgQZlAAAAAlwSFlzAAAhOAAAITgBRZYxYAAAABtJREFUCJljYGJgYGBgBhGM2AhmJiYGBmZGRgABeQAX6nqJcQAAAABJRU5ErkJggg==","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/loginDialogBottom.png
/* harmony default export */ var loginDialogBottom = ({"src":"/_next/static/media/loginDialogBottom.f3fc1657.png","height":306,"width":168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAMAAADp7a43AAAACVBMVEUB++sB+utMaXEVpb/yAAAAA3RSTlMSPQCPPPt+AAAACXBIWXMAACE4AAAhOAFFljFgAAAAFUlEQVQImWNgYmJiYsBJgAEjIyMjAATiADU6E09eAAAAAElFTkSuQmCC","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/loginDialogRightBottom.png
/* harmony default export */ var loginDialogRightBottom = ({"src":"/_next/static/media/loginDialogRightBottom.5153fbb6.png","height":306,"width":351,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAD1BMVEUB+usA++wB++tMaXEC++vLQNbsAAAABXRSTlMINSYAF4r9+nYAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAgSURBVAiZY2AGAwYmBnQGIxYGBDAyMbAwMjEyMjIxAwAQWQB0DX0pLgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/views/providers/MetamaskChecker/MetamaskConnectionProvider/Layout.tsx






















var Layout = function Layout(_ref) {
  var children = _ref.children,
      onClickConnectToMetamsk = _ref.onClickConnectToMetamsk,
      visibleLoading = _ref.visibleLoading,
      state = _ref.state;

  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: state.type === 'INVISIBLE' ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: children
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [state.type === 'REQUIRED_USER_ACCOUNT_CONNECTED' ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PinkNeonButton/* PinkNeonButton */.u, {
          type: "Sub",
          size: "S",
          onClick: onClickConnectToMetamsk,
          loading: visibleLoading,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
            className: "items-center justify-center ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
              className: "relative mr-2 aspect-[99/90] w-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: metamaskLogo/* default */.Z,
                layout: "fill",
                alt: ""
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
              className: "text-sm text-white",
              children: t('MetamaskConnectionChecker.AlertConnectButton')
            })]
          })
        })
      }) : null, state.type === 'WRONG_CHAIN_ID' || state.type === 'WRONG_WALLET_ADDRESS' ? /*#__PURE__*/(0,jsx_runtime.jsx)(Fixed/* Fixed */.g, {
        className: "top-0 left-0 z-50 h-screen w-screen bg-black bg-opacity-80",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
          className: "h-full w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
            className: "w-1/2 max-w-[700px] items-center p-[18px]",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Absolute/* Absolute */.e, {
              className: "top-0 left-0 bottom-0 w-full p-[9px]",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
                className: "w-full",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
                  className: "w-full",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
                    className: "relative aspect-[168/295] w-12",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      priority: true,
                      src: loginDialogLeftTop,
                      layout: "fill",
                      alt: "Logo"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
                    className: "relative mr-2 w-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      priority: true,
                      src: loginDialogTop,
                      layout: "fill",
                      alt: "Logo"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
                    className: "relative flex-1",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      priority: true,
                      src: loginDialogTop,
                      layout: "fill",
                      alt: "Logo"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
                    className: "relative aspect-[168/295] w-12",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      priority: true,
                      src: loginDialogRightTop,
                      layout: "fill",
                      alt: "Logo"
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
                  className: "w-full flex-1",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
                    className: "relative aspect-[54/12] w-[15.5px]",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      priority: true,
                      src: loginDialogVerticalBorder,
                      layout: "fill",
                      alt: "Logo"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
                    className: "relative aspect-[54/12] w-[15.5px]",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      priority: true,
                      src: loginDialogVerticalBorder,
                      layout: "fill",
                      alt: "Logo"
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
                  className: "w-full",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
                    className: "relative aspect-[168/306] w-12",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      priority: true,
                      src: loginDialogLeftBottom,
                      layout: "fill",
                      alt: "Logo"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
                    className: "relative flex-1",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      priority: true,
                      src: loginDialogBottom,
                      layout: "fill",
                      alt: "Logo"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
                    className: "relative aspect-[315/306] w-[100px]",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      priority: true,
                      src: loginDialogRightBottom,
                      layout: "fill",
                      alt: "Logo"
                    })
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
              className: "min-h-[200px] w-full items-center justify-center rounded-[22px] bg-black p-6",
              children: [state.type === 'WRONG_WALLET_ADDRESS' ? /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                className: "text-center text-white",
                children: t('MetamaskConnectionChecker.AlertDescriptionRequiredMetamaskPermission', {
                  walletAddress: state.walletAddress
                })
              }) : null, state.type === 'WRONG_CHAIN_ID' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
                className: "items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
                  className: "relative mt-7 mb-9 aspect-[99/90] w-20",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: metamaskLogo/* default */.Z,
                    layout: "fill",
                    alt: ""
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                  className: "text-center text-white",
                  children: t('MetamaskConnectionChecker.AlertDescriptionWrongChainId', {
                    networkName: t("MetamaskConnectionChecker.".concat("0x89"))
                  })
                })]
              }) : null]
            })]
          })
        })
      }) : null]
    })
  });
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/views/states/MetamaskWalletAddress/index.tsx
var MetamaskWalletAddress = __webpack_require__(6079);
// EXTERNAL MODULE: ./src/services/MetamaskService.ts
var MetamaskService = __webpack_require__(2483);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var recoil_es = __webpack_require__(4480);
;// CONCATENATED MODULE: ./src/views/states/MetamaskWalletChainId/index.tsx




var walletAddressAtom = (0,recoil_es/* atom */.cn)({
  key: 'MetamaskWalletChainId',
  "default": undefined
});
var useMetamaskWalletChainId = function useMetamaskWalletChainId() {
  var _useRecoilState = (0,recoil_es/* useRecoilState */.FV)(walletAddressAtom),
      _useRecoilState2 = (0,slicedToArray/* default */.Z)(_useRecoilState, 2),
      chainId = _useRecoilState2[0],
      setWalletChainId = _useRecoilState2[1];

  var updateChainId = (0,react.useCallback)(function () {
    MetamaskService/* MetamaskService.getCurrentChainId */.G.getCurrentChainId().then(function (id) {
      setWalletChainId(id ? "0x".concat(id.toString(16)) : undefined);
    });
  }, [setWalletChainId]);
  (0,react.useEffect)(function () {
    updateChainId();
    window.ethereum.on('chainChanged', updateChainId);
    return function () {
      window.ethereum.removeListener('chainChanged', updateChainId);
    };
  }, [updateChainId]);
  return {
    chainId: chainId
  };
};
// EXTERNAL MODULE: ./src/views/states/LoginUser/index.tsx + 1 modules
var LoginUser = __webpack_require__(8655);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(1383);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(1230);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(319);
;// CONCATENATED MODULE: ./src/views/providers/MetamaskChecker/MetamaskConnectionProvider/query.generated.ts
var _templateObject,_templateObject2;function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){(0,defineProperty/* default */.Z)(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}var defaultOptions={};/** All built-in and custom scalars, mapped to their actual values */var ActiveBoosterForTournamentScalarFieldEnum;(function(ActiveBoosterForTournamentScalarFieldEnum){ActiveBoosterForTournamentScalarFieldEnum["Category"]="category";ActiveBoosterForTournamentScalarFieldEnum["CreatedAt"]="createdAt";ActiveBoosterForTournamentScalarFieldEnum["EndAt"]="endAt";ActiveBoosterForTournamentScalarFieldEnum["Id"]="id";ActiveBoosterForTournamentScalarFieldEnum["PaidTournamentId"]="paidTournamentId";ActiveBoosterForTournamentScalarFieldEnum["SubCategory"]="subCategory";ActiveBoosterForTournamentScalarFieldEnum["UpdatedAt"]="updatedAt";ActiveBoosterForTournamentScalarFieldEnum["UserId"]="userId";})(ActiveBoosterForTournamentScalarFieldEnum||(ActiveBoosterForTournamentScalarFieldEnum={}));var ActiveBoosterScalarFieldEnum;(function(ActiveBoosterScalarFieldEnum){ActiveBoosterScalarFieldEnum["Category"]="category";ActiveBoosterScalarFieldEnum["CreatedAt"]="createdAt";ActiveBoosterScalarFieldEnum["EndAt"]="endAt";ActiveBoosterScalarFieldEnum["Id"]="id";ActiveBoosterScalarFieldEnum["SubCategory"]="subCategory";ActiveBoosterScalarFieldEnum["UpdatedAt"]="updatedAt";ActiveBoosterScalarFieldEnum["UserId"]="userId";})(ActiveBoosterScalarFieldEnum||(ActiveBoosterScalarFieldEnum={}));var ArcadeMachineScalarFieldEnum;(function(ArcadeMachineScalarFieldEnum){ArcadeMachineScalarFieldEnum["AccumulatorSubCategory"]="accumulatorSubCategory";ArcadeMachineScalarFieldEnum["AutoRenewLease"]="autoRenewLease";ArcadeMachineScalarFieldEnum["Boost"]="boost";ArcadeMachineScalarFieldEnum["CreatedAt"]="createdAt";ArcadeMachineScalarFieldEnum["DestroyedAt"]="destroyedAt";ArcadeMachineScalarFieldEnum["Energy"]="energy";ArcadeMachineScalarFieldEnum["ExtractedEnergy"]="extractedEnergy";ArcadeMachineScalarFieldEnum["FeverSparkRemain"]="feverSparkRemain";ArcadeMachineScalarFieldEnum["Game"]="game";ArcadeMachineScalarFieldEnum["GameCenterId"]="gameCenterId";ArcadeMachineScalarFieldEnum["Id"]="id";ArcadeMachineScalarFieldEnum["InstalledAt"]="installedAt";ArcadeMachineScalarFieldEnum["LastBlock"]="lastBlock";ArcadeMachineScalarFieldEnum["LastTransactionIndex"]="lastTransactionIndex";ArcadeMachineScalarFieldEnum["LowerCabinetSubCategory"]="lowerCabinetSubCategory";ArcadeMachineScalarFieldEnum["MaxEnergy"]="maxEnergy";ArcadeMachineScalarFieldEnum["OwnerWalletAddress"]="ownerWalletAddress";ArcadeMachineScalarFieldEnum["PhysicalWalletAddress"]="physicalWalletAddress";ArcadeMachineScalarFieldEnum["Position"]="position";ArcadeMachineScalarFieldEnum["State"]="state";ArcadeMachineScalarFieldEnum["UpdatedAt"]="updatedAt";ArcadeMachineScalarFieldEnum["UpperCabinetSubCategory"]="upperCabinetSubCategory";ArcadeMachineScalarFieldEnum["UserId"]="userId";})(ArcadeMachineScalarFieldEnum||(ArcadeMachineScalarFieldEnum={}));var ArcadePartCategory;(function(ArcadePartCategory){ArcadePartCategory["Accumulator"]="ACCUMULATOR";ArcadePartCategory["LowerCabinet"]="LOWER_CABINET";ArcadePartCategory["Rom"]="ROM";ArcadePartCategory["UpperCabinet"]="UPPER_CABINET";})(ArcadePartCategory||(ArcadePartCategory={}));var ArcadePartScalarFieldEnum;(function(ArcadePartScalarFieldEnum){ArcadePartScalarFieldEnum["Category"]="category";ArcadePartScalarFieldEnum["CraftId"]="craftId";ArcadePartScalarFieldEnum["CreateDismantleId"]="createDismantleId";ArcadePartScalarFieldEnum["CreatedAt"]="createdAt";ArcadePartScalarFieldEnum["DestroyedAt"]="destroyedAt";ArcadePartScalarFieldEnum["Id"]="id";ArcadePartScalarFieldEnum["LastBlock"]="lastBlock";ArcadePartScalarFieldEnum["LastTransactionIndex"]="lastTransactionIndex";ArcadePartScalarFieldEnum["OwnerWalletAddress"]="ownerWalletAddress";ArcadePartScalarFieldEnum["PhysicalWalletAddress"]="physicalWalletAddress";ArcadePartScalarFieldEnum["State"]="state";ArcadePartScalarFieldEnum["SubCategory"]="subCategory";ArcadePartScalarFieldEnum["UpdatedAt"]="updatedAt";ArcadePartScalarFieldEnum["UsedJunks"]="usedJunks";ArcadePartScalarFieldEnum["UserId"]="userId";})(ArcadePartScalarFieldEnum||(ArcadePartScalarFieldEnum={}));var BannerImageType;(function(BannerImageType){BannerImageType["Banner"]="BANNER";BannerImageType["Interstitial"]="INTERSTITIAL";BannerImageType["PaidTournament"]="PAID_TOURNAMENT";})(BannerImageType||(BannerImageType={}));var BannerScalarFieldEnum;(function(BannerScalarFieldEnum){BannerScalarFieldEnum["BgImageUrl"]="bgImageUrl";BannerScalarFieldEnum["CreatedAt"]="createdAt";BannerScalarFieldEnum["Description"]="description";BannerScalarFieldEnum["Display"]="display";BannerScalarFieldEnum["EndAt"]="endAt";BannerScalarFieldEnum["ExternalLink"]="externalLink";BannerScalarFieldEnum["FrontEndType"]="frontEndType";BannerScalarFieldEnum["Id"]="id";BannerScalarFieldEnum["MainImageUrl"]="mainImageUrl";BannerScalarFieldEnum["StartAt"]="startAt";BannerScalarFieldEnum["TargetArea"]="targetArea";BannerScalarFieldEnum["UpdatedAt"]="updatedAt";})(BannerScalarFieldEnum||(BannerScalarFieldEnum={}));var BoosterCategory;(function(BoosterCategory){BoosterCategory["EasyMode"]="EASY_MODE";BoosterCategory["GameSwap"]="GAME_SWAP";BoosterCategory["SparkTerasUp"]="SPARK_TERAS_UP";})(BoosterCategory||(BoosterCategory={}));var BoosterMasterScalarFieldEnum;(function(BoosterMasterScalarFieldEnum){BoosterMasterScalarFieldEnum["Category"]="category";BoosterMasterScalarFieldEnum["CreatedAt"]="createdAt";BoosterMasterScalarFieldEnum["EffectiveMinutes"]="effectiveMinutes";BoosterMasterScalarFieldEnum["FeeTickets"]="feeTickets";BoosterMasterScalarFieldEnum["Id"]="id";BoosterMasterScalarFieldEnum["RequireTournament"]="requireTournament";BoosterMasterScalarFieldEnum["SubCategory"]="subCategory";BoosterMasterScalarFieldEnum["UpdatedAt"]="updatedAt";BoosterMasterScalarFieldEnum["Variant"]="variant";})(BoosterMasterScalarFieldEnum||(BoosterMasterScalarFieldEnum={}));var BurnScalarFieldEnum;(function(BurnScalarFieldEnum){BurnScalarFieldEnum["CreatedAt"]="createdAt";BurnScalarFieldEnum["ErrorMessage"]="errorMessage";BurnScalarFieldEnum["Hash"]="hash";BurnScalarFieldEnum["Id"]="id";BurnScalarFieldEnum["NftType"]="nftType";BurnScalarFieldEnum["Nonce"]="nonce";BurnScalarFieldEnum["Response"]="response";BurnScalarFieldEnum["SignerAddress"]="signerAddress";BurnScalarFieldEnum["State"]="state";BurnScalarFieldEnum["TokenId"]="tokenId";BurnScalarFieldEnum["UpdatedAt"]="updatedAt";BurnScalarFieldEnum["UserId"]="userId";})(BurnScalarFieldEnum||(BurnScalarFieldEnum={}));var BurnState;(function(BurnState){BurnState["Confirmed"]="CONFIRMED";BurnState["Error"]="ERROR";BurnState["Pending"]="PENDING";BurnState["Unprocessed"]="UNPROCESSED";})(BurnState||(BurnState={}));var CollectibleItemCategory;(function(CollectibleItemCategory){CollectibleItemCategory["Frame"]="FRAME";CollectibleItemCategory["Icon"]="ICON";CollectibleItemCategory["Title"]="TITLE";})(CollectibleItemCategory||(CollectibleItemCategory={}));var CollectibleItemScalarFieldEnum;(function(CollectibleItemScalarFieldEnum){CollectibleItemScalarFieldEnum["Category"]="category";CollectibleItemScalarFieldEnum["CreatedAt"]="createdAt";CollectibleItemScalarFieldEnum["Id"]="id";CollectibleItemScalarFieldEnum["SubCategory"]="subCategory";CollectibleItemScalarFieldEnum["UpdatedAt"]="updatedAt";CollectibleItemScalarFieldEnum["UserId"]="userId";})(CollectibleItemScalarFieldEnum||(CollectibleItemScalarFieldEnum={}));/** Currency used for crafting */var CraftCurrencyType;(function(CraftCurrencyType){CraftCurrencyType["Akv"]="AKV";CraftCurrencyType["Teras"]="TERAS";})(CraftCurrencyType||(CraftCurrencyType={}));var CraftScalarFieldEnum;(function(CraftScalarFieldEnum){CraftScalarFieldEnum["CraftedArcadeMachineId"]="craftedArcadeMachineId";CraftScalarFieldEnum["CreatedAt"]="createdAt";CraftScalarFieldEnum["Id"]="id";CraftScalarFieldEnum["UpdatedAt"]="updatedAt";CraftScalarFieldEnum["UsedAkvBalance"]="usedAkvBalance";CraftScalarFieldEnum["UsedTerasBalance"]="usedTerasBalance";CraftScalarFieldEnum["UserId"]="userId";})(CraftScalarFieldEnum||(CraftScalarFieldEnum={}));var CurrencyDepositScalarFieldEnum;(function(CurrencyDepositScalarFieldEnum){CurrencyDepositScalarFieldEnum["Amount"]="amount";CurrencyDepositScalarFieldEnum["CreatedAt"]="createdAt";CurrencyDepositScalarFieldEnum["CurrencyType"]="currencyType";CurrencyDepositScalarFieldEnum["Hash"]="hash";CurrencyDepositScalarFieldEnum["Id"]="id";CurrencyDepositScalarFieldEnum["State"]="state";CurrencyDepositScalarFieldEnum["UpdatedAt"]="updatedAt";CurrencyDepositScalarFieldEnum["UserId"]="userId";CurrencyDepositScalarFieldEnum["WalletAddress"]="walletAddress";})(CurrencyDepositScalarFieldEnum||(CurrencyDepositScalarFieldEnum={}));var CurrencyType;(function(CurrencyType){CurrencyType["Akir"]="AKIR";CurrencyType["Akv"]="AKV";CurrencyType["Usdc"]="USDC";})(CurrencyType||(CurrencyType={}));var DepositScalarFieldEnum;(function(DepositScalarFieldEnum){DepositScalarFieldEnum["CreatedAt"]="createdAt";DepositScalarFieldEnum["Hash"]="hash";DepositScalarFieldEnum["Id"]="id";DepositScalarFieldEnum["NftType"]="nftType";DepositScalarFieldEnum["State"]="state";DepositScalarFieldEnum["TokenId"]="tokenId";DepositScalarFieldEnum["UpdatedAt"]="updatedAt";DepositScalarFieldEnum["UserId"]="userId";DepositScalarFieldEnum["WalletAddress"]="walletAddress";})(DepositScalarFieldEnum||(DepositScalarFieldEnum={}));var DepositState;(function(DepositState){DepositState["Confirmed"]="CONFIRMED";DepositState["Invalidated"]="INVALIDATED";DepositState["Pending"]="PENDING";DepositState["Unprocessed"]="UNPROCESSED";})(DepositState||(DepositState={}));/** Currency used for dismantle */var DismantleCurrencyType;(function(DismantleCurrencyType){DismantleCurrencyType["Akv"]="AKV";DismantleCurrencyType["Teras"]="TERAS";})(DismantleCurrencyType||(DismantleCurrencyType={}));var DismantleScalarFieldEnum;(function(DismantleScalarFieldEnum){DismantleScalarFieldEnum["ArcadeMachineId"]="arcadeMachineId";DismantleScalarFieldEnum["CreatedAt"]="createdAt";DismantleScalarFieldEnum["FeverSparkRemain"]="feverSparkRemain";DismantleScalarFieldEnum["Id"]="id";DismantleScalarFieldEnum["UserId"]="userId";})(DismantleScalarFieldEnum||(DismantleScalarFieldEnum={}));/** Currency used for extracting */var ExtractCurrencyType;(function(ExtractCurrencyType){ExtractCurrencyType["Akv"]="AKV";ExtractCurrencyType["Teras"]="TERAS";})(ExtractCurrencyType||(ExtractCurrencyType={}));var ExtractInitialInventoryScalarFieldEnum;(function(ExtractInitialInventoryScalarFieldEnum){ExtractInitialInventoryScalarFieldEnum["Category"]="category";ExtractInitialInventoryScalarFieldEnum["CreatedAt"]="createdAt";ExtractInitialInventoryScalarFieldEnum["FeaturedItem"]="featuredItem";ExtractInitialInventoryScalarFieldEnum["Id"]="id";ExtractInitialInventoryScalarFieldEnum["InitialAmount"]="initialAmount";ExtractInitialInventoryScalarFieldEnum["ItemType"]="itemType";ExtractInitialInventoryScalarFieldEnum["SeasonId"]="seasonId";ExtractInitialInventoryScalarFieldEnum["SubCategory"]="subCategory";ExtractInitialInventoryScalarFieldEnum["UpdatedAt"]="updatedAt";})(ExtractInitialInventoryScalarFieldEnum||(ExtractInitialInventoryScalarFieldEnum={}));var ExtractJunkInventoryScalarFieldEnum;(function(ExtractJunkInventoryScalarFieldEnum){ExtractJunkInventoryScalarFieldEnum["Amount"]="amount";ExtractJunkInventoryScalarFieldEnum["Category"]="category";ExtractJunkInventoryScalarFieldEnum["CreatedAt"]="createdAt";ExtractJunkInventoryScalarFieldEnum["SubCategory"]="subCategory";ExtractJunkInventoryScalarFieldEnum["UpdatedAt"]="updatedAt";})(ExtractJunkInventoryScalarFieldEnum||(ExtractJunkInventoryScalarFieldEnum={}));var ExtractScalarFieldEnum;(function(ExtractScalarFieldEnum){ExtractScalarFieldEnum["ArcadeMachineId"]="arcadeMachineId";ExtractScalarFieldEnum["CreatedAt"]="createdAt";ExtractScalarFieldEnum["ExtractArcadePartsCount"]="extractArcadePartsCount";ExtractScalarFieldEnum["ExtractDetail"]="extractDetail";ExtractScalarFieldEnum["ExtractJunkPartsCount"]="extractJunkPartsCount";ExtractScalarFieldEnum["Id"]="id";ExtractScalarFieldEnum["UpdatedAt"]="updatedAt";ExtractScalarFieldEnum["UserId"]="userId";})(ExtractScalarFieldEnum||(ExtractScalarFieldEnum={}));var ExtractableItemType;(function(ExtractableItemType){ExtractableItemType["ArcadePart"]="ARCADE_PART";ExtractableItemType["JunkPart"]="JUNK_PART";})(ExtractableItemType||(ExtractableItemType={}));var FrontEndType;(function(FrontEndType){FrontEndType["Gp"]="GP";FrontEndType["Wm"]="WM";})(FrontEndType||(FrontEndType={}));var GameCenterArea;(function(GameCenterArea){GameCenterArea["Akihabara"]="AKIHABARA";GameCenterArea["Shibuya"]="SHIBUYA";})(GameCenterArea||(GameCenterArea={}));var GameCenterScalarFieldEnum;(function(GameCenterScalarFieldEnum){GameCenterScalarFieldEnum["Area"]="area";GameCenterScalarFieldEnum["CreatedAt"]="createdAt";GameCenterScalarFieldEnum["Id"]="id";GameCenterScalarFieldEnum["LastBlock"]="lastBlock";GameCenterScalarFieldEnum["LastTransactionIndex"]="lastTransactionIndex";GameCenterScalarFieldEnum["Name"]="name";GameCenterScalarFieldEnum["OwnerWalletAddress"]="ownerWalletAddress";GameCenterScalarFieldEnum["PhysicalWalletAddress"]="physicalWalletAddress";GameCenterScalarFieldEnum["PlacementAllowed"]="placementAllowed";GameCenterScalarFieldEnum["Size"]="size";GameCenterScalarFieldEnum["State"]="state";GameCenterScalarFieldEnum["UpdatedAt"]="updatedAt";GameCenterScalarFieldEnum["UserId"]="userId";GameCenterScalarFieldEnum["XCoordinate"]="xCoordinate";GameCenterScalarFieldEnum["YCoordinate"]="yCoordinate";})(GameCenterScalarFieldEnum||(GameCenterScalarFieldEnum={}));var GameCenterSize;(function(GameCenterSize){GameCenterSize["Large"]="LARGE";GameCenterSize["Medium"]="MEDIUM";GameCenterSize["Small"]="SMALL";})(GameCenterSize||(GameCenterSize={}));var IconType;(function(IconType){IconType["InWorld"]="IN_WORLD";IconType["Nft"]="NFT";})(IconType||(IconType={}));var InterstitialBannerScalarFieldEnum;(function(InterstitialBannerScalarFieldEnum){InterstitialBannerScalarFieldEnum["CreatedAt"]="createdAt";InterstitialBannerScalarFieldEnum["Description"]="description";InterstitialBannerScalarFieldEnum["Display"]="display";InterstitialBannerScalarFieldEnum["EndAt"]="endAt";InterstitialBannerScalarFieldEnum["ExternalLink"]="externalLink";InterstitialBannerScalarFieldEnum["Id"]="id";InterstitialBannerScalarFieldEnum["ImageUrl"]="imageUrl";InterstitialBannerScalarFieldEnum["RemainingTimeVisible"]="remainingTimeVisible";InterstitialBannerScalarFieldEnum["StartAt"]="startAt";InterstitialBannerScalarFieldEnum["TargetArea"]="targetArea";InterstitialBannerScalarFieldEnum["UpdatedAt"]="updatedAt";})(InterstitialBannerScalarFieldEnum||(InterstitialBannerScalarFieldEnum={}));var JunkScalarFieldEnum;(function(JunkScalarFieldEnum){JunkScalarFieldEnum["Amount"]="amount";JunkScalarFieldEnum["Category"]="category";JunkScalarFieldEnum["CreatedAt"]="createdAt";JunkScalarFieldEnum["Id"]="id";JunkScalarFieldEnum["SubCategory"]="subCategory";JunkScalarFieldEnum["UpdatedAt"]="updatedAt";JunkScalarFieldEnum["UserId"]="userId";})(JunkScalarFieldEnum||(JunkScalarFieldEnum={}));var NewsCategory;(function(NewsCategory){NewsCategory["Event"]="EVENT";NewsCategory["Info"]="INFO";NewsCategory["Promo"]="PROMO";})(NewsCategory||(NewsCategory={}));var NewsScalarFieldEnum;(function(NewsScalarFieldEnum){NewsScalarFieldEnum["Category"]="category";NewsScalarFieldEnum["CreatedAt"]="createdAt";NewsScalarFieldEnum["Display"]="display";NewsScalarFieldEnum["EndAt"]="endAt";NewsScalarFieldEnum["ExternalLink"]="externalLink";NewsScalarFieldEnum["Id"]="id";NewsScalarFieldEnum["StartAt"]="startAt";NewsScalarFieldEnum["Title"]="title";NewsScalarFieldEnum["UpdatedAt"]="updatedAt";})(NewsScalarFieldEnum||(NewsScalarFieldEnum={}));var NftState;(function(NftState){NftState["Burned"]="BURNED";NftState["Burning"]="BURNING";NftState["InAkiverse"]="IN_AKIVERSE";NftState["InWallet"]="IN_WALLET";NftState["MovingToAkiverse"]="MOVING_TO_AKIVERSE";NftState["MovingToWallet"]="MOVING_TO_WALLET";})(NftState||(NftState={}));var NftType;(function(NftType){NftType["ArcadeMachine"]="ARCADE_MACHINE";NftType["ArcadePart"]="ARCADE_PART";NftType["GameCenter"]="GAME_CENTER";})(NftType||(NftType={}));var NotificationScalarFieldEnum;(function(NotificationScalarFieldEnum){NotificationScalarFieldEnum["CreatedAt"]="createdAt";NotificationScalarFieldEnum["Id"]="id";NotificationScalarFieldEnum["MessageDetailJson"]="messageDetailJson";NotificationScalarFieldEnum["MessageJson"]="messageJson";NotificationScalarFieldEnum["NftType"]="nftType";NotificationScalarFieldEnum["NotificationType"]="notificationType";NotificationScalarFieldEnum["TokenId"]="tokenId";NotificationScalarFieldEnum["UpdatedAt"]="updatedAt";NotificationScalarFieldEnum["UserId"]="userId";})(NotificationScalarFieldEnum||(NotificationScalarFieldEnum={}));var NotificationType;(function(NotificationType){NotificationType["Activity"]="ACTIVITY";NotificationType["Information"]="INFORMATION";})(NotificationType||(NotificationType={}));var NullsOrder;(function(NullsOrder){NullsOrder["First"]="first";NullsOrder["Last"]="last";})(NullsOrder||(NullsOrder={}));var OperatingSystem;(function(OperatingSystem){OperatingSystem["Android"]="ANDROID";OperatingSystem["Ios"]="IOS";})(OperatingSystem||(OperatingSystem={}));var PaidTournamentBoosterAvailableScalarFieldEnum;(function(PaidTournamentBoosterAvailableScalarFieldEnum){PaidTournamentBoosterAvailableScalarFieldEnum["BoosterMasterId"]="boosterMasterId";PaidTournamentBoosterAvailableScalarFieldEnum["CreatedAt"]="createdAt";PaidTournamentBoosterAvailableScalarFieldEnum["Id"]="id";PaidTournamentBoosterAvailableScalarFieldEnum["PaidTournamentId"]="paidTournamentId";PaidTournamentBoosterAvailableScalarFieldEnum["UpdatedAt"]="updatedAt";})(PaidTournamentBoosterAvailableScalarFieldEnum||(PaidTournamentBoosterAvailableScalarFieldEnum={}));var PaidTournamentEntryScalarFieldEnum;(function(PaidTournamentEntryScalarFieldEnum){PaidTournamentEntryScalarFieldEnum["CountryFromIp"]="countryFromIp";PaidTournamentEntryScalarFieldEnum["CreatedAt"]="createdAt";PaidTournamentEntryScalarFieldEnum["Id"]="id";PaidTournamentEntryScalarFieldEnum["PaidTournamentId"]="paidTournamentId";PaidTournamentEntryScalarFieldEnum["PhoneNumber"]="phoneNumber";PaidTournamentEntryScalarFieldEnum["PrizeClaimed"]="prizeClaimed";PaidTournamentEntryScalarFieldEnum["PrizeSendStatus"]="prizeSendStatus";PaidTournamentEntryScalarFieldEnum["UpdatedAt"]="updatedAt";PaidTournamentEntryScalarFieldEnum["UsedTickets"]="usedTickets";PaidTournamentEntryScalarFieldEnum["UserId"]="userId";PaidTournamentEntryScalarFieldEnum["WalletAddress"]="walletAddress";})(PaidTournamentEntryScalarFieldEnum||(PaidTournamentEntryScalarFieldEnum={}));var PaidTournamentScalarFieldEnum;(function(PaidTournamentScalarFieldEnum){PaidTournamentScalarFieldEnum["CreatedAt"]="createdAt";PaidTournamentScalarFieldEnum["EndAt"]="endAt";PaidTournamentScalarFieldEnum["EntryFeeTickets"]="entryFeeTickets";PaidTournamentScalarFieldEnum["GameId"]="gameId";PaidTournamentScalarFieldEnum["Id"]="id";PaidTournamentScalarFieldEnum["ImageUrl"]="imageUrl";PaidTournamentScalarFieldEnum["PaidTournamentType"]="paidTournamentType";PaidTournamentScalarFieldEnum["PrizeSent"]="prizeSent";PaidTournamentScalarFieldEnum["PrizeTerasAmount"]="prizeTerasAmount";PaidTournamentScalarFieldEnum["PrizeTerasOnly"]="prizeTerasOnly";PaidTournamentScalarFieldEnum["ResultRecorded"]="resultRecorded";PaidTournamentScalarFieldEnum["StartAt"]="startAt";PaidTournamentScalarFieldEnum["TargetArea"]="targetArea";PaidTournamentScalarFieldEnum["Title"]="title";PaidTournamentScalarFieldEnum["UpdatedAt"]="updatedAt";})(PaidTournamentScalarFieldEnum||(PaidTournamentScalarFieldEnum={}));var PaidTournamentType;(function(PaidTournamentType){PaidTournamentType["SparkCount"]="SPARK_COUNT";PaidTournamentType["SparkTeras"]="SPARK_TERAS";})(PaidTournamentType||(PaidTournamentType={}));var PlayResult;(function(PlayResult){PlayResult["Disconnected"]="DISCONNECTED";PlayResult["Loss"]="LOSS";PlayResult["Win"]="WIN";})(PlayResult||(PlayResult={}));var PlayScalarFieldEnum;(function(PlayScalarFieldEnum){PlayScalarFieldEnum["CreatedAt"]="createdAt";PlayScalarFieldEnum["EndedAt"]="endedAt";PlayScalarFieldEnum["Id"]="id";PlayScalarFieldEnum["MegaSpark"]="megaSpark";PlayScalarFieldEnum["OwnerTerasReward"]="ownerTerasReward";PlayScalarFieldEnum["PlaySessionId"]="playSessionId";PlayScalarFieldEnum["PlayerTerasReward"]="playerTerasReward";PlayScalarFieldEnum["Result"]="result";PlayScalarFieldEnum["Score"]="score";PlayScalarFieldEnum["TerasBoosterRatio"]="terasBoosterRatio";PlayScalarFieldEnum["UpdatedAt"]="updatedAt";})(PlayScalarFieldEnum||(PlayScalarFieldEnum={}));var PlaySessionScalarFieldEnum;(function(PlaySessionScalarFieldEnum){PlaySessionScalarFieldEnum["ArcadeMachineId"]="arcadeMachineId";PlaySessionScalarFieldEnum["ArcadeMachineOwnerId"]="arcadeMachineOwnerId";PlaySessionScalarFieldEnum["AuthToken"]="authToken";PlaySessionScalarFieldEnum["CreatedAt"]="createdAt";PlaySessionScalarFieldEnum["Difficulty"]="difficulty";PlaySessionScalarFieldEnum["EndedAt"]="endedAt";PlaySessionScalarFieldEnum["Fever"]="fever";PlaySessionScalarFieldEnum["GameCenterId"]="gameCenterId";PlaySessionScalarFieldEnum["GameCenterOwnerId"]="gameCenterOwnerId";PlaySessionScalarFieldEnum["Id"]="id";PlaySessionScalarFieldEnum["MaxPlayCount"]="maxPlayCount";PlaySessionScalarFieldEnum["PlayerId"]="playerId";PlaySessionScalarFieldEnum["State"]="state";PlaySessionScalarFieldEnum["TargetScore"]="targetScore";PlaySessionScalarFieldEnum["UpdatedAt"]="updatedAt";})(PlaySessionScalarFieldEnum||(PlaySessionScalarFieldEnum={}));var PlaySessionState;(function(PlaySessionState){PlaySessionState["Finished"]="FINISHED";PlaySessionState["Playing"]="PLAYING";PlaySessionState["Ready"]="READY";})(PlaySessionState||(PlaySessionState={}));/** Prize claim type */var PrizeClaimType;(function(PrizeClaimType){PrizeClaimType["PhoneNumber"]="PHONE_NUMBER";PrizeClaimType["WalletAddress"]="WALLET_ADDRESS";})(PrizeClaimType||(PrizeClaimType={}));var PrizeSendStatus;(function(PrizeSendStatus){PrizeSendStatus["Confirmed"]="CONFIRMED";PrizeSendStatus["Error"]="ERROR";PrizeSendStatus["Pending"]="PENDING";PrizeSendStatus["Unprocessed"]="UNPROCESSED";})(PrizeSendStatus||(PrizeSendStatus={}));var PurchaseStatus;(function(PurchaseStatus){PurchaseStatus["Canceled"]="CANCELED";PurchaseStatus["Granted"]="GRANTED";PurchaseStatus["Invalid"]="INVALID";PurchaseStatus["Unprocessed"]="UNPROCESSED";})(PurchaseStatus||(PurchaseStatus={}));var QueryMode;(function(QueryMode){QueryMode["Default"]="default";QueryMode["Insensitive"]="insensitive";})(QueryMode||(QueryMode={}));var QuestChainCategory;(function(QuestChainCategory){QuestChainCategory["Event"]="EVENT";QuestChainCategory["Onward"]="ONWARD";QuestChainCategory["Vip"]="VIP";})(QuestChainCategory||(QuestChainCategory={}));var QuestChainMasterScalarFieldEnum;(function(QuestChainMasterScalarFieldEnum){QuestChainMasterScalarFieldEnum["AkvRequiredForRelease"]="akvRequiredForRelease";QuestChainMasterScalarFieldEnum["BeforeQuestChainId"]="beforeQuestChainId";QuestChainMasterScalarFieldEnum["ChainCategory"]="chainCategory";QuestChainMasterScalarFieldEnum["EndAt"]="endAt";QuestChainMasterScalarFieldEnum["Id"]="id";QuestChainMasterScalarFieldEnum["SpecifiedTitleImage"]="specifiedTitleImage";QuestChainMasterScalarFieldEnum["StartAt"]="startAt";QuestChainMasterScalarFieldEnum["TerasRequiredForRelease"]="terasRequiredForRelease";QuestChainMasterScalarFieldEnum["TicketRequiredForRelease"]="ticketRequiredForRelease";QuestChainMasterScalarFieldEnum["Title"]="title";})(QuestChainMasterScalarFieldEnum||(QuestChainMasterScalarFieldEnum={}));var QuestChainRewardMasterScalarFieldEnum;(function(QuestChainRewardMasterScalarFieldEnum){QuestChainRewardMasterScalarFieldEnum["Amount"]="amount";QuestChainRewardMasterScalarFieldEnum["Category"]="category";QuestChainRewardMasterScalarFieldEnum["Id"]="id";QuestChainRewardMasterScalarFieldEnum["ItemType"]="itemType";QuestChainRewardMasterScalarFieldEnum["QuestChainMasterId"]="questChainMasterId";QuestChainRewardMasterScalarFieldEnum["SubCategory"]="subCategory";})(QuestChainRewardMasterScalarFieldEnum||(QuestChainRewardMasterScalarFieldEnum={}));var QuestChainScalarFieldEnum;(function(QuestChainScalarFieldEnum){QuestChainScalarFieldEnum["AcceptedAt"]="acceptedAt";QuestChainScalarFieldEnum["Completed"]="completed";QuestChainScalarFieldEnum["CreatedAt"]="createdAt";QuestChainScalarFieldEnum["ExpiredAt"]="expiredAt";QuestChainScalarFieldEnum["Id"]="id";QuestChainScalarFieldEnum["QuestChainMasterId"]="questChainMasterId";QuestChainScalarFieldEnum["UpdatedAt"]="updatedAt";QuestChainScalarFieldEnum["UserId"]="userId";})(QuestChainScalarFieldEnum||(QuestChainScalarFieldEnum={}));var QuestMasterScalarFieldEnum;(function(QuestMasterScalarFieldEnum){QuestMasterScalarFieldEnum["Amount"]="amount";QuestMasterScalarFieldEnum["BeforeQuestIds"]="beforeQuestIds";QuestMasterScalarFieldEnum["Category"]="category";QuestMasterScalarFieldEnum["Id"]="id";QuestMasterScalarFieldEnum["ItemType"]="itemType";QuestMasterScalarFieldEnum["ProgressGoal"]="progressGoal";QuestMasterScalarFieldEnum["ProgressParams"]="progressParams";QuestMasterScalarFieldEnum["ProgressType"]="progressType";QuestMasterScalarFieldEnum["QuestChainMasterId"]="questChainMasterId";QuestMasterScalarFieldEnum["Seq"]="seq";QuestMasterScalarFieldEnum["SubCategory"]="subCategory";QuestMasterScalarFieldEnum["Title"]="title";})(QuestMasterScalarFieldEnum||(QuestMasterScalarFieldEnum={}));var QuestProgressType;(function(QuestProgressType){QuestProgressType["ConnectWallet"]="CONNECT_WALLET";QuestProgressType["ConsecutivePlayDaysInDifferentGame"]="CONSECUTIVE_PLAY_DAYS_IN_DIFFERENT_GAME";QuestProgressType["ConsecutiveSparkCount"]="CONSECUTIVE_SPARK_COUNT";QuestProgressType["ConsecutiveSparkDays"]="CONSECUTIVE_SPARK_DAYS";QuestProgressType["PlayCount"]="PLAY_COUNT";QuestProgressType["SparkCount"]="SPARK_COUNT";QuestProgressType["UniqueGamePlayCount"]="UNIQUE_GAME_PLAY_COUNT";QuestProgressType["UniqueGameSparkCount"]="UNIQUE_GAME_SPARK_COUNT";QuestProgressType["UniquePlayDays"]="UNIQUE_PLAY_DAYS";})(QuestProgressType||(QuestProgressType={}));var QuestRewardCategory;(function(QuestRewardCategory){QuestRewardCategory["Accumulator"]="ACCUMULATOR";QuestRewardCategory["Frame"]="FRAME";QuestRewardCategory["Icon"]="ICON";QuestRewardCategory["LowerCabinet"]="LOWER_CABINET";QuestRewardCategory["Random"]="RANDOM";QuestRewardCategory["Rom"]="ROM";QuestRewardCategory["Teras"]="TERAS";QuestRewardCategory["Title"]="TITLE";QuestRewardCategory["UpperCabinet"]="UPPER_CABINET";})(QuestRewardCategory||(QuestRewardCategory={}));var QuestRewardType;(function(QuestRewardType){QuestRewardType["ArcadePart"]="ARCADE_PART";QuestRewardType["ArcadePartRandom"]="ARCADE_PART_RANDOM";QuestRewardType["CollectibleItem"]="COLLECTIBLE_ITEM";QuestRewardType["JunkPart"]="JUNK_PART";QuestRewardType["JunkPartRandom"]="JUNK_PART_RANDOM";QuestRewardType["Teras"]="TERAS";})(QuestRewardType||(QuestRewardType={}));var QuestScalarFieldEnum;(function(QuestScalarFieldEnum){QuestScalarFieldEnum["CompletedAt"]="completedAt";QuestScalarFieldEnum["CreatedAt"]="createdAt";QuestScalarFieldEnum["Id"]="id";QuestScalarFieldEnum["QuestChainId"]="questChainId";QuestScalarFieldEnum["QuestMasterId"]="questMasterId";QuestScalarFieldEnum["StartAt"]="startAt";QuestScalarFieldEnum["UpdatedAt"]="updatedAt";})(QuestScalarFieldEnum||(QuestScalarFieldEnum={}));var RewardCategory;(function(RewardCategory){RewardCategory["Accumulator"]="ACCUMULATOR";RewardCategory["Frame"]="FRAME";RewardCategory["Icon"]="ICON";RewardCategory["LowerCabinet"]="LOWER_CABINET";RewardCategory["Rom"]="ROM";RewardCategory["Teras"]="TERAS";RewardCategory["Title"]="TITLE";RewardCategory["UpperCabinet"]="UPPER_CABINET";})(RewardCategory||(RewardCategory={}));var RewardItemType;(function(RewardItemType){RewardItemType["ArcadePart"]="ARCADE_PART";RewardItemType["CollectibleItem"]="COLLECTIBLE_ITEM";RewardItemType["JunkPart"]="JUNK_PART";RewardItemType["Teras"]="TERAS";})(RewardItemType||(RewardItemType={}));var RewardScalarFieldEnum;(function(RewardScalarFieldEnum){RewardScalarFieldEnum["AcceptedAt"]="acceptedAt";RewardScalarFieldEnum["Amount"]="amount";RewardScalarFieldEnum["AvailableUntil"]="availableUntil";RewardScalarFieldEnum["Category"]="category";RewardScalarFieldEnum["CreatedAt"]="createdAt";RewardScalarFieldEnum["Id"]="id";RewardScalarFieldEnum["RewardItemType"]="rewardItemType";RewardScalarFieldEnum["SubCategory"]="subCategory";RewardScalarFieldEnum["Title"]="title";RewardScalarFieldEnum["UpdatedAt"]="updatedAt";RewardScalarFieldEnum["UserId"]="userId";})(RewardScalarFieldEnum||(RewardScalarFieldEnum={}));var SortOrder;(function(SortOrder){SortOrder["Asc"]="asc";SortOrder["Desc"]="desc";})(SortOrder||(SortOrder={}));/** Currency used for start quest chain */var StartQuestChainCurrencyType;(function(StartQuestChainCurrencyType){StartQuestChainCurrencyType["Akv"]="AKV";StartQuestChainCurrencyType["Teras"]="TERAS";StartQuestChainCurrencyType["Ticket"]="TICKET";})(StartQuestChainCurrencyType||(StartQuestChainCurrencyType={}));var TicketTransactionType;(function(TicketTransactionType){TicketTransactionType["EnterTournament"]="ENTER_TOURNAMENT";TicketTransactionType["OpenQuest"]="OPEN_QUEST";TicketTransactionType["Purchase"]="PURCHASE";TicketTransactionType["TournamentBooster"]="TOURNAMENT_BOOSTER";})(TicketTransactionType||(TicketTransactionType={}));var UserScalarFieldEnum;(function(UserScalarFieldEnum){UserScalarFieldEnum["Admin"]="admin";UserScalarFieldEnum["AkirBalance"]="akirBalance";UserScalarFieldEnum["AkvBalance"]="akvBalance";UserScalarFieldEnum["CreatedAt"]="createdAt";UserScalarFieldEnum["Email"]="email";UserScalarFieldEnum["FrameSubCategory"]="frameSubCategory";UserScalarFieldEnum["IconSubCategory"]="iconSubCategory";UserScalarFieldEnum["IconType"]="iconType";UserScalarFieldEnum["Id"]="id";UserScalarFieldEnum["LockedAt"]="lockedAt";UserScalarFieldEnum["Name"]="name";UserScalarFieldEnum["TerasBalance"]="terasBalance";UserScalarFieldEnum["Tickets"]="tickets";UserScalarFieldEnum["TitleSubCategory"]="titleSubCategory";UserScalarFieldEnum["UpdatedAt"]="updatedAt";UserScalarFieldEnum["WalletAddress"]="walletAddress";})(UserScalarFieldEnum||(UserScalarFieldEnum={}));var WithdrawalState;(function(WithdrawalState){WithdrawalState["Confirmed"]="CONFIRMED";WithdrawalState["Error"]="ERROR";WithdrawalState["Pending"]="PENDING";WithdrawalState["Unprocessed"]="UNPROCESSED";})(WithdrawalState||(WithdrawalState={}));var WithdrawalType;(function(WithdrawalType){WithdrawalType["Mint"]="MINT";WithdrawalType["Transfer"]="TRANSFER";})(WithdrawalType||(WithdrawalType={}));var RequestWeb3ChallengeDocument=(0,lib/* gql */.Ps)(_templateObject||(_templateObject=(0,taggedTemplateLiteral/* default */.Z)(["\n    mutation requestWeb3Challenge($input: RequestWeb3ChallengeInput!) {\n  RequestWeb3Challenge(input: $input) {\n    message\n    sessionToken\n  }\n}\n    "])));/**
 * __useRequestWeb3ChallengeMutation__
 *
 * To run a mutation, you first call `useRequestWeb3ChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestWeb3ChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestWeb3ChallengeMutation, { data, loading, error }] = useRequestWeb3ChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */function useRequestWeb3ChallengeMutation(baseOptions){var options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return useMutation/* useMutation */.D(RequestWeb3ChallengeDocument,options);}var RegisterWalletAddressDocument=(0,lib/* gql */.Ps)(_templateObject2||(_templateObject2=(0,taggedTemplateLiteral/* default */.Z)(["\n    mutation registerWalletAddress($input: RegisterWalletAddressInput!) {\n  registerWalletAddress(input: $input) {\n    user {\n      id\n      walletAddress\n    }\n  }\n}\n    "])));/**
 * __useRegisterWalletAddressMutation__
 *
 * To run a mutation, you first call `useRegisterWalletAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterWalletAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerWalletAddressMutation, { data, loading, error }] = useRegisterWalletAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */function useRegisterWalletAddressMutation(baseOptions){var options=_objectSpread(_objectSpread({},defaultOptions),baseOptions);return useMutation/* useMutation */.D(RegisterWalletAddressDocument,options);}
// EXTERNAL MODULE: ./src/services/AuthService.ts
var AuthService = __webpack_require__(746);
// EXTERNAL MODULE: ./src/services/FirebaseService.ts + 1 modules
var FirebaseService = __webpack_require__(5732);
;// CONCATENATED MODULE: ./src/views/providers/MetamaskChecker/MetamaskConnectionProvider/useProps.ts











var useProps = function useProps() {
  var _loginUser$walletAddr;

  var _useLoginUser = (0,LoginUser/* useLoginUser */.x)(),
      loginUser = _useLoginUser.loginUser,
      reload = _useLoginUser.reload;

  var userWalletAddress = (_loginUser$walletAddr = loginUser === null || loginUser === void 0 ? void 0 : loginUser.walletAddress) !== null && _loginUser$walletAddr !== void 0 ? _loginUser$walletAddr : '';
  var currentMetamskWalletAddress = (0,MetamaskWalletAddress/* useMetamaskWalletAddress */.I)().walletAddress;
  var chainId = useMetamaskWalletChainId().chainId;

  var _useState = (0,react.useState)({
    type: 'INVISIBLE'
  }),
      state = _useState[0],
      setState = _useState[1];

  var _useRequestWeb3Challe = useRequestWeb3ChallengeMutation(),
      _useRequestWeb3Challe2 = (0,slicedToArray/* default */.Z)(_useRequestWeb3Challe, 1),
      requestWeb3Challenge = _useRequestWeb3Challe2[0];

  var _useRegisterWalletAdd = useRegisterWalletAddressMutation(),
      _useRegisterWalletAdd2 = (0,slicedToArray/* default */.Z)(_useRegisterWalletAdd, 1),
      registerWalletAddress = _useRegisterWalletAdd2[0];

  var _useState2 = (0,react.useState)(false),
      visibleLoading = _useState2[0],
      setVisibleLoading = _useState2[1];

  (0,react.useEffect)(function () {
    if (!AuthService/* AuthService.isLoggedIn */.e.isLoggedIn()) {
      setState({
        type: 'INVISIBLE'
      });
    } else if (!currentMetamskWalletAddress || !MetamaskService/* MetamaskService.isValidAddress */.G.isValidAddress(userWalletAddress)) {
      console.warn('User wallet is different from current Metamask wallet. ', {
        userWallet: userWalletAddress,
        MetamskWallet: currentMetamskWalletAddress
      });
      setState({
        type: 'REQUIRED_USER_ACCOUNT_CONNECTED'
      });
    } else if (currentMetamskWalletAddress !== userWalletAddress) {
      setState({
        type: 'WRONG_WALLET_ADDRESS',
        walletAddress: userWalletAddress
      });
    } else if (chainId !== "0x89") {
      MetamaskService/* MetamaskService.switchToSupportedChain */.G.switchToSupportedChain();
      setState({
        type: 'WRONG_CHAIN_ID'
      });
    } else {
      setState({
        type: 'INVISIBLE'
      });
    }
  }, [userWalletAddress, currentMetamskWalletAddress, chainId]);
  return {
    state: state,
    visibleLoading: visibleLoading,
    onClickConnectToMetamsk: function () {
      var _onClickConnectToMetamsk = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                setVisibleLoading(true);
                MetamaskService/* MetamaskService.requestConnectionToMetamsk */.G.requestConnectionToMetamsk().then( /*#__PURE__*/function () {
                  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(result) {
                    var walletAddress;
                    return regenerator_default().wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!result) {
                              setVisibleLoading(false);
                            }

                            _context3.next = 3;
                            return MetamaskService/* MetamaskService.getWalletAddress */.G.getWalletAddress();

                          case 3:
                            walletAddress = _context3.sent;

                            if (!MetamaskService/* MetamaskService.isValidAddress */.G.isValidAddress(userWalletAddress)) {
                              requestWeb3Challenge({
                                variables: {
                                  input: {
                                    chain: "0x89",
                                    walletAddress: walletAddress
                                  }
                                }
                              }).then( /*#__PURE__*/function () {
                                var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(res) {
                                  var _res$data$RequestWeb, _res$data;

                                  var _res$errors, _res$errors$, errorMessage, message, signature;

                                  return regenerator_default().wrap(function _callee2$(_context2) {
                                    while (1) {
                                      switch (_context2.prev = _context2.next) {
                                        case 0:
                                          if (!res.errors) {
                                            _context2.next = 3;
                                            break;
                                          }

                                          errorMessage = res !== null && res !== void 0 && (_res$errors = res.errors) !== null && _res$errors !== void 0 && (_res$errors$ = _res$errors[0]) !== null && _res$errors$ !== void 0 && _res$errors$.message ? res.errors[0].message : '';
                                          return _context2.abrupt("return", alert("Error : Connect failed.\n".concat(errorMessage)));

                                        case 3:
                                          message = (_res$data$RequestWeb = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.RequestWeb3Challenge.message) !== null && _res$data$RequestWeb !== void 0 ? _res$data$RequestWeb : '';
                                          _context2.next = 6;
                                          return MetamaskService/* MetamaskService.signMessage */.G.signMessage(message);

                                        case 6:
                                          signature = _context2.sent;
                                          registerWalletAddress({
                                            variables: {
                                              input: {
                                                message: message,
                                                signature: signature
                                              }
                                            }
                                          }).then( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                                            var _auth$currentUser;

                                            return regenerator_default().wrap(function _callee$(_context) {
                                              while (1) {
                                                switch (_context.prev = _context.next) {
                                                  case 0:
                                                    _context.next = 2;
                                                    return (_auth$currentUser = FirebaseService/* auth.currentUser */.I.currentUser) === null || _auth$currentUser === void 0 ? void 0 : _auth$currentUser.getIdToken(true);

                                                  case 2:
                                                    _context.next = 4;
                                                    return reload();

                                                  case 4:
                                                    setVisibleLoading(false);

                                                  case 5:
                                                  case "end":
                                                    return _context.stop();
                                                }
                                              }
                                            }, _callee);
                                          })))["catch"](function (e) {
                                            alert('Error : ' + e.message);
                                            setVisibleLoading(false);
                                          });

                                        case 8:
                                        case "end":
                                          return _context2.stop();
                                      }
                                    }
                                  }, _callee2);
                                }));

                                return function (_x2) {
                                  return _ref2.apply(this, arguments);
                                };
                              }())["catch"](function () {
                                setVisibleLoading(false);
                              });
                            }

                          case 5:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function onClickConnectToMetamsk() {
        return _onClickConnectToMetamsk.apply(this, arguments);
      }

      return onClickConnectToMetamsk;
    }()
  };
};
;// CONCATENATED MODULE: ./src/views/providers/MetamaskChecker/MetamaskConnectionProvider/index.tsx


function MetamaskConnectionProvider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MetamaskConnectionProvider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MetamaskConnectionProvider_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MetamaskConnectionProvider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MetamaskConnectionChecker = function MetamaskConnectionChecker(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout, MetamaskConnectionProvider_objectSpread(MetamaskConnectionProvider_objectSpread({}, useProps()), {}, {
    children: children
  }));
};
;// CONCATENATED MODULE: ./src/views/providers/MetamaskChecker/MetamaskInstallCheckerProvider/Layout.tsx











var Layout_Layout = function Layout(_ref) {
  var children = _ref.children,
      visible = _ref.visible,
      onClickInstall = _ref.onClickInstall;

  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: visible ? /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
      className: "relative",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PinkNeonButton/* PinkNeonButton */.u, {
        type: "Sub",
        size: "S",
        onClick: onClickInstall,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
          className: "items-center justify-center ",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
            className: "relative mr-2 aspect-[99/90] w-4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: metamaskLogo/* default */.Z,
              layout: "fill",
              alt: ""
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
            className: "text-sm text-white",
            children: t('MetamaskInstallChecker.AlertDescription')
          })]
        })
      })
    }) : children
  });
};
;// CONCATENATED MODULE: ./src/views/providers/MetamaskChecker/MetamaskInstallCheckerProvider/useProps.ts

var useProps_useProps = function useProps() {
  return {
    visible: !MetamaskService/* MetamaskService.isInstalledMetamask */.G.isInstalledMetamask(),
    onClickInstall: function onClickInstall() {
      window.open('https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn');
    }
  };
};
;// CONCATENATED MODULE: ./src/views/providers/MetamaskChecker/MetamaskInstallCheckerProvider/index.tsx


function MetamaskInstallCheckerProvider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MetamaskInstallCheckerProvider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MetamaskInstallCheckerProvider_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MetamaskInstallCheckerProvider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MetamaskInstallCheckerProvider = function MetamaskInstallCheckerProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout_Layout, MetamaskInstallCheckerProvider_objectSpread(MetamaskInstallCheckerProvider_objectSpread({}, useProps_useProps()), {}, {
    children: children
  }));
};
;// CONCATENATED MODULE: ./src/views/providers/MetamaskChecker/index.tsx




var MetamaskChecker = function MetamaskChecker(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MetamaskInstallCheckerProvider, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MetamaskConnectionChecker, {
      children: children
    })
  });
};
// EXTERNAL MODULE: ./src/assets/constants.ts
var constants = __webpack_require__(1279);
;// CONCATENATED MODULE: ./src/views/parts/commons/GlobalNavigationHeader/Layout.tsx

















var GlobalNavigationHeader_Layout_Layout = function Layout(props) {
  var shortWalletAddress = props.connectedWallet.replace(/^(\w{5})\w+(\w{4})$/, '$1...$2');

  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(HStack/* HStack */.U, {
    className: "h-14 w-full bg-black",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
      className: "h-full w-full items-center bg-gradient-to-r from-gradient-headerLeft to-gradient-headerRight",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
        className: "relative h-full w-64 items-center justify-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: "h-9",
          src: logo,
          width: 146,
          height: 36,
          alt: "logo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Absolute/* Absolute */.e, {
          className: "bottom-1",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
            className: "text-xs font-semibold text-white",
            style: {
              textShadow: '0px 0px 3px rgba(255, 255, 255, 0.7)'
            },
            children: constants/* DISPLAY_VERSION */.xv
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {}), props.isLoggedIn && /*#__PURE__*/(0,jsx_runtime.jsx)(MetamaskChecker, {
        children: shortWalletAddress.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
          className: "items-center",
          children: [props.visibleSpinner ? /*#__PURE__*/(0,jsx_runtime.jsx)(ContractProcessingStatus, {
            depositing: props.depositing,
            withdrawing: props.withdrawing
          }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: metamaskLogo/* default */.Z,
            width: 24,
            height: 24,
            objectFit: "contain",
            alt: ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
            className: "ml-2 mr-10 font-bold text-white",
            children: shortWalletAddress
          })]
        }) : null
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Clickable/* Clickable */.P, {
        className: "flex h-full items-center justify-center px-7",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: " font-bold text-white  opacity-40",
          children: t('WorldManagerGlobalHeader.stakingLink')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Absolute/* Absolute */.e, {
          className: "bottom-0.5",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
            className: "text-xs font-semibold text-primary-textActive",
            children: t('Common.comingSoon')
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Clickable/* Clickable */.P, {
        className: "flex h-full items-center justify-center px-7",
        onClick: props.onClickMarketPlace,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: " font-bold text-white hover:text-primary-textActive",
          children: t('WorldManagerGlobalHeader.marketplaceLink')
        })
      })]
    })
  });
};

var ContractProcessingStatus = function ContractProcessingStatus(props) {
  var _useTranslation2 = (0,es/* useTranslation */.$G)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Center/* Center */.M, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "p-3",
      "data-tip": true,
      "data-for": "tooltip",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
        size: 18,
        visible: true,
        color: "#00FBEC"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* default */.Z, {
      id: "tooltip",
      place: "bottom",
      backgroundColor: "black",
      borderColor: "#888",
      border: true,
      padding: "6px 10px",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "text-xs text-white",
        children: [props.depositing.map(function (name, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
            className: "items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
              size: 12,
              visible: true,
              color: "#00FBEC"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
              className: "ml-2 text-sm text-neon-blue",
              children: [name, " ", t('WorldManagerGlobalHeader.depositing')]
            })]
          }, i);
        }), props.withdrawing.map(function (name, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
            className: "items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
              size: 12,
              visible: true,
              color: "#00FBEC"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
              className: "ml-2 text-sm text-neon-blue",
              children: [name, " ", t('WorldManagerGlobalHeader.withdrawing')]
            })]
          }, i);
        })]
      })
    })]
  });
};

/***/ }),

/***/ 2317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useProps; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7812);
/* harmony import */ var _src_views_states_LoginUser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _services_ExternalUrlService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8106);
/* harmony import */ var _states_ProcessingContactsContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90);
/* harmony import */ var _src_services_AuthService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(746);






var useProps = function useProps() {
  var _useLoginUser$loginUs, _useLoginUser$loginUs2;

  var onClickStaking = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    return window.open(_services_ExternalUrlService__WEBPACK_IMPORTED_MODULE_2__/* .ExternalUrlService.getStakingUrl */ .b.getStakingUrl());
  }, []);
  var onClickMarketPlace = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    return window.open(_services_ExternalUrlService__WEBPACK_IMPORTED_MODULE_2__/* .ExternalUrlService.getTofuNftAkiverseAPPage */ .b.getTofuNftAkiverseAPPage());
  }, []);
  var walletAddress = (_useLoginUser$loginUs = (_useLoginUser$loginUs2 = (0,_src_views_states_LoginUser__WEBPACK_IMPORTED_MODULE_0__/* .useLoginUser */ .x)().loginUser) === null || _useLoginUser$loginUs2 === void 0 ? void 0 : _useLoginUser$loginUs2.walletAddress) !== null && _useLoginUser$loginUs !== void 0 ? _useLoginUser$loginUs : '';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoggedIn = _useState[0],
      setLoggedIn = _useState[1];

  var _useProcessingContact = (0,_states_ProcessingContactsContext__WEBPACK_IMPORTED_MODULE_3__/* .useProcessingContactsContext */ .m)(),
      depositingGameCenters = _useProcessingContact.depositingGameCenters,
      withdrawingGameCenters = _useProcessingContact.withdrawingGameCenters,
      depositingArcadeMachines = _useProcessingContact.depositingArcadeMachines,
      withdrawingArcadeMachines = _useProcessingContact.withdrawingArcadeMachines,
      depositingArcadeParts = _useProcessingContact.depositingArcadeParts,
      withdrawingArcadeParts = _useProcessingContact.withdrawingArcadeParts,
      depositingAKV = _useProcessingContact.depositingAKV,
      withdrawingAKV = _useProcessingContact.withdrawingAKV,
      depositingAKIR = _useProcessingContact.depositingAKIR,
      withdrawingAKIR = _useProcessingContact.withdrawingAKIR;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setLoggedIn(_src_services_AuthService__WEBPACK_IMPORTED_MODULE_4__/* .AuthService.isLoggedIn */ .e.isLoggedIn());
  }, []);
  return {
    onClickMarketPlace: onClickMarketPlace,
    onClickStaking: onClickStaking,
    connectedWallet: walletAddress,
    visibleSpinner: [].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(depositingGameCenters), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(withdrawingGameCenters), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(depositingArcadeMachines), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(withdrawingArcadeMachines), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(depositingArcadeParts), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(withdrawingArcadeParts), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(depositingAKV), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(withdrawingAKV), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(depositingAKIR), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(withdrawingAKIR)).length > 0,
    depositing: [].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(depositingGameCenters.map(function (gc) {
      return gc.name;
    })), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(depositingArcadeMachines.map(function (am) {
      return am.name;
    })), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(depositingArcadeParts.map(function (ap) {
      return ap.name;
    })), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(depositingAKV.map(function (akv) {
      return "AKV x".concat(Number(akv.amount.toAKV()).toLocaleString());
    })), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(depositingAKIR.map(function (akir) {
      return "AKIR x".concat(Number(akir.amount).toLocaleString());
    }))),
    withdrawing: [].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(withdrawingGameCenters.map(function (gc) {
      return gc.name;
    })), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(withdrawingArcadeMachines.map(function (am) {
      return am.name;
    })), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(withdrawingArcadeParts.map(function (ap) {
      return ap.name;
    })), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(withdrawingAKV.map(function (akv) {
      return "AKV x".concat(Number(akv.amount.toAKV()).toLocaleString());
    })), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(withdrawingAKIR.map(function (akir) {
      return "AKIR x".concat(Number(akir.amount).toLocaleString());
    }))),
    isLoggedIn: isLoggedIn
  };
};

/***/ }),

/***/ 4974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);


var Spinner = function Spinner(props) {
  var _props$color;

  return props.visible ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "flex justify-center",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "animate-spin rounded-full border-2 border-t-transparent",
      style: {
        height: props.size,
        width: props.size,
        borderColor: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : 'white',
        borderTopColor: 'transparent'
      }
    })
  }) : null;
};

/***/ }),

/***/ 6079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useMetamaskWalletAddress; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6835);
/* harmony import */ var _src_services_MetamaskService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2483);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4480);




var walletAddressAtom = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .atom */ .cn)({
  key: 'MetamaskWalletAddress',
  "default": ''
});
var useMetamaskWalletAddress = function useMetamaskWalletAddress() {
  var _useRecoilState = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilState */ .FV)(walletAddressAtom),
      _useRecoilState2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useRecoilState, 2),
      walletAddress = _useRecoilState2[0],
      setWalletAddress = _useRecoilState2[1];

  var updateWalletAddress = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    _src_services_MetamaskService__WEBPACK_IMPORTED_MODULE_0__/* .MetamaskService.getWalletAddress */ .G.getWalletAddress().then(function (address) {
      setWalletAddress(address !== null && address !== void 0 ? address : '');
    });
  }, [setWalletAddress]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!_src_services_MetamaskService__WEBPACK_IMPORTED_MODULE_0__/* .MetamaskService.isInstalledMetamask */ .G.isInstalledMetamask()) return;
    updateWalletAddress();
    window.ethereum.on('accountsChanged', updateWalletAddress);
    return function () {
      window.ethereum.removeListener('accountsChanged', updateWalletAddress);
    };
  }, [updateWalletAddress]);
  return {
    walletAddress: walletAddress
  };
};

/***/ }),

/***/ 6912:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/metamaskLogo.7448d400.png","height":90,"width":99,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAYFBMVEVyPBm4YB5/Qxr/iyfjfTPQbSGSTBzidSPXdCHYcCTIah9xOxn9iR7leSPgcB/KnYD7hx/fcSCahnp0PRmUTh11PRl2Phnoeib0gyDqfSXEahvadiL9iB6zXh99QRp1a2Q1hENDAAAAGHRSTlP8pL89gv39/i39/tbI6pqjXbbgbs1skGM6Dq8IAAAACXBIWXMAACE4AAAhOAFFljFgAAAAP0lEQVQImQXBCQKAIAgEwLVQoPsOxer/v2wGTWhF7uME3sc84UKPZB2wI0TNrEUw1GjKdcHouTgzgab522iVH1jUAvlYCemHAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 2808:
/***/ (function() {

/* (ignored) */

/***/ })

}]);